/* gallery-closet-store.js  My Closet data layer (localStorage).
   Multiple named lists of saved products. Shared by the header badge, the PDP
   "Add to My Lists" modal, and the My Closet page. Exposes window.GLYCloset and
   fires a 'gly-closet:change' event on every mutation so any open view re-renders.
   Persistence is client-side only (no account sync). */
(function () {
  'use strict';

  var KEY = 'gly_closet_v1';
  var MAX_LISTS = 6;

  function uid() {
    return 'l' + Math.random().toString(36).slice(2, 9) + Date.now().toString(36).slice(-4);
  }

  function defaultState() {
    return { lists: [{ id: 'wishlist', name: 'Wishlist', items: [] }] };
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return defaultState();
      var s = JSON.parse(raw);
      if (!s || !Array.isArray(s.lists)) return defaultState();
      // Always guarantee the default wishlist exists.
      if (!s.lists.some(function (l) { return l.id === 'wishlist'; })) {
        s.lists.unshift({ id: 'wishlist', name: 'Wishlist', items: [] });
      }
      return s;
    } catch (e) { return defaultState(); }
  }

  function write(state) {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('gly-closet:change')); } catch (e) {}
  }

  function findList(state, id) {
    for (var i = 0; i < state.lists.length; i++) { if (state.lists[i].id === id) return state.lists[i]; }
    return null;
  }

  var GLYCloset = {
    getLists: function () { return read().lists; },

    getList: function (id) { return findList(read(), id); },

    MAX_LISTS: MAX_LISTS,

    /* true when another list can still be created (under the cap) */
    canCreateList: function () { return read().lists.length < MAX_LISTS; },

    /* Creates a list, or returns null if the max-list cap is reached. */
    createList: function (name) {
      var state = read();
      if (state.lists.length >= MAX_LISTS) return null;
      var list = { id: uid(), name: String(name || 'New list').slice(0, 60), items: [] };
      state.lists.push(list);
      write(state);
      return list;
    },

    deleteList: function (id) {
      if (id === 'wishlist') return; // default list is undeletable
      var state = read();
      state.lists = state.lists.filter(function (l) { return l.id !== id; });
      write(state);
    },

    renameList: function (id, name) {
      var state = read();
      var l = findList(state, id);
      if (l) { l.name = String(name || l.name).slice(0, 60); write(state); }
    },

    /* item: {id, handle, url, title, image, price, compareAt, variantId, color, size} */
    addItemToList: function (listId, item) {
      var state = read();
      var l = findList(state, listId);
      if (!l || !item || item.id == null) return;
      var pid = String(item.id);
      if (l.items.some(function (it) { return String(it.id) === pid; })) return; // no dupes per list
      l.items.unshift(item);
      write(state);
    },

    removeItemFromList: function (listId, itemId) {
      var state = read();
      var l = findList(state, listId);
      if (!l) return;
      var pid = String(itemId);
      l.items = l.items.filter(function (it) { return String(it.id) !== pid; });
      write(state);
    },

    /* which list ids currently contain this product */
    listsWithItem: function (productId) {
      var pid = String(productId);
      return read().lists
        .filter(function (l) { return l.items.some(function (it) { return String(it.id) === pid; }); })
        .map(function (l) { return l.id; });
    },

    isSaved: function (productId) { return this.listsWithItem(productId).length > 0; },

    /* distinct products saved across all lists (for the header badge) */
    savedCount: function () {
      var seen = {};
      read().lists.forEach(function (l) { l.items.forEach(function (it) { seen[String(it.id)] = 1; }); });
      return Object.keys(seen).length;
    },

    /* ---- cart helpers (used by the closet page's Add to bag / Add all) ---- */
    addToCart: function (variantId, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
      }).then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); });
    },

    cartCount: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { return c.item_count; })
        .catch(function () { return 0; });
    }
  };

  window.GLYCloset = GLYCloset;

  /* Hydrate any header closet badges on load and on change. */
  function paintBadges() {
    var n = GLYCloset.savedCount();
    document.querySelectorAll('[data-closet-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  document.addEventListener('gly-closet:change', paintBadges);
  if (document.readyState !== 'loading') paintBadges();
  else document.addEventListener('DOMContentLoaded', paintBadges);
})();
